// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import {
  getStorage,
  ref,
  listAll,
  getMetadata,
  deleteObject,
} from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDPj3OACX4LFi7vYb5owGdQgzFvSVYlAtM",
  authDomain: "file-box-9dddb.firebaseapp.com",
  projectId: "file-box-9dddb",
  storageBucket: "file-box-9dddb.appspot.com",
  messagingSenderId: "868430474895",
  appId: "1:868430474895:web:7b35c8e4b419f2c1614afa",
  measurementId: "G-0WSBP8GJPN",
};
console.log("Firebase initializeApp");

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Get a reference to the storage service, which is used to create references in your storage bucket
export const storage = getStorage(firebaseApp);

export const auth = getAuth();
signInAnonymously(auth)
  .then(() => {
    // Signed in..
    console.log("Firebase anonymous auth success");
    getAllFiles();
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorCode, errorMessage);
    // ...
  });

function getAllFiles() {
  const listRef = ref(storage, `/file`);
  listAll(listRef)
    .then((res) => {
      res.items.forEach((itemRef) => {
        // All the items under listRef.
        const pathFile = itemRef._location.path_;

        const forestRef = ref(storage, pathFile);
        getMetadata(forestRef)
          .then((metadata) => {
            var dateUpload = new Date(metadata.timeCreated);

            var newDate = new Date();

            var difference = getDifferenceInDays2(dateUpload, newDate);

            if (difference > 3) {
              deleteObject(forestRef)
                .then(() => {
                  // File deleted successfully
                  console.log("file delete");
                })
                .catch((error) => {
                  console.log("error delete file");
                  // Uh-oh, an error occurred!
                });
            }
          })
          .catch((error) => {});
      });
    })
    .catch((error) => {
      // Uh-oh, an error occurred!
    });
}

function getDifferenceInDays2(d1, d2) {
  var t2 = d2.getTime();
  var t1 = d1.getTime();

  return parseInt((t2 - t1) / (24 * 3600 * 1000));
}
